export function simpleMemoize(f) {
    var cache = {};
    var hasFn = function (o) {
        return !!Object.keys(o).find(function (key) { return typeof o[key] === 'function'; });
    };
    function memoized() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var index = JSON.stringify(args);
        var hasFns = !!args.find(function (arg) {
            return typeof arg === 'function' || (typeof arg === 'object' && hasFn(arg));
        });
        if (cache[index] && !hasFns) {
            return cache[index];
        }
        else {
            var result = f.apply(void 0, args);
            if (!hasFns) {
                cache[index] = result;
            }
            return result;
        }
    }
    memoized.clearCache = function () { return (cache = {}); };
    // @ts-ignore
    return memoized;
}
//# sourceMappingURL=simpleMemoize.js.map